import { Link } from "react-router-dom";

const ITEMS = [
  "The 3D You Approve Is The Home You Get",
  "19 Years of Turnkey Practice",
  "J.J. School of Art Alumni",
  "6 Dedicated Execution Teams",
  "Mumbai",
  "Navi Mumbai",
  "Pune",
  "Delhi",
  "Lucknow",
];

function Track({ ariaHidden = false }: { ariaHidden?: boolean }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-8 font-serif text-2xl italic tracking-wide text-gold/50 md:text-3xl">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/30" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee will-change-transform">
        <Track />
        <Track ariaHidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
}
